import { put, call } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { AUTHENTICATE_USER_RESPONSE, AUTHENTICATE_USER_FAILED } from '../redux/types/authenticate';
import UserApi from "../services/userApi";
import triggerAPI from '../services/triggerAPI';
import { endpoints } from '../services/endpoints';
import { commonError } from '../helper/constant';
import { GETDITAUTHTOKEN_FAILED, GETDITAUTHTOKEN_RESPONSE } from '../redux/types/ditUserToken';
let api = new UserApi();
const triApi = new triggerAPI();

const dummyAuthenticate = () => {
    return new Promise((resolve, reject) => {
        // setTimeout(() => {
        resolve({ data: { success: true } })
        // }, 2000);
    })
}

export function* authenticateUser() {
    try {
        let { data } = yield api.validateToken();
        console.log(`verify user token and refreshToken `, data)
        if (data.success) {
            console.log(`data success`)
            yield put({ type: AUTHENTICATE_USER_RESPONSE })
        } else {
            console.log(`data false`)
            yield put(push('/'));
            yield put({ type: AUTHENTICATE_USER_FAILED })
        }
    } catch (e) {
        console.log(`data catch`, e)
        yield put(push('/'));
        yield put({ type: AUTHENTICATE_USER_FAILED })
    }
}

export function* getDITAuthToken({ payload, resolve }) {
    try {
        let { data } = yield triApi.triggerAPI(payload, endpoints.login.GetDITAuthToken);
        if (data.success) {
            yield put({ type: GETDITAUTHTOKEN_RESPONSE, payload: data.data })
            resolve && resolve(data.data)
        } else {
            resolve && resolve(data)
            yield put({ type: GETDITAUTHTOKEN_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: GETDITAUTHTOKEN_FAILED, payload: commonError })
    }

}